<template>
    <div id="home">
        <div class="ribbon"></div>
        <div class="pad-top">
            <v-card class="mx-auto"
                    max-width="500">
                <v-card-title class="justify-center">Conditions Générales d'Utilisation</v-card-title>

                <v-container>
                    <div>
                        En utilisant l'assistant <b>Dahub</b>, vous acceptez les Conditions Générales d'Utilisation.
                        <a target="_blank" href="/documents/CGU_Saas_Dahub_v01_09_2022__Annexe_1_v01_09_2022.pdf">
                            Voir les CGU.
                        </a>

                        <v-checkbox v-model="accept" :label="'J\'accepte les Conditions Générales d\'Utilisation.'">
                        </v-checkbox>

                        <div class="text-center">
                            <v-btn @click="acceptCgu" :disabled="!accept" class="default-button">Valider</v-btn>
                        </div>
                    </div>
                </v-container>
            </v-card>
        </div>
    </div>

</template>

<script>
    import {mapMutations, mapState} from "vuex"

    export default {
        name: "AcceptCgu",
        data() {
            return {
                accept: false
            }
        },
        methods: {
            ...mapMutations('account', [
                'setDisplayWelcomeTour'
            ]),
            async acceptCgu() {
                this.$global.loading = true

                await this.$http.get('auth/user/accept-cgu')

                this.setDisplayWelcomeTour(true)

                this.$global.loading = false

                this.$router.push('/home')
            }
        },
        computed: {
            ...mapState('account', ['user'])
        }
    }
</script>
